import { apiGet, apiPost, getToken } from './api';

const API_BASE = import.meta.env.VITE_API_BASE ?? '';

export type IntegField = {
  name: string;
  label: string;
  type: 'text' | 'password' | 'select';
  options?: string[];
  placeholder?: string;
};
export type Integration = {
  key: string;
  title: string;
  desc: string;
  fields: IntegField[];
  canTest: boolean;
  canSync: boolean;
  syncLabel: string | null;
  enabled: boolean;
  status: string | null;
  last_sync: string | null;
  config: Record<string, string>;
  webhook_url?: string;
  secret?: string;
};

export const listIntegrations = () => apiGet<{ integrations: Integration[] }>('/api/integrations');

export async function saveIntegration(
  key: string,
  enabled: boolean,
  config: Record<string, string>,
) {
  const res = await fetch(`${API_BASE}/api/integrations/${key}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
    },
    body: JSON.stringify({ enabled, config }),
  });
  if (!res.ok) throw new Error('save failed');
  return res.json();
}
export const testIntegration = (key: string) =>
  apiPost<{ ok: boolean; message: string }>(`/api/integrations/${key}/test`);
export const syncIntegration = (key: string) =>
  apiPost<{ ok: boolean; message: string; imported?: number }>(`/api/integrations/${key}/sync`);
